import * as localStorage from "../../../utils/localStorage";

export default interface CachedModulesSet {
  has(moduleId: string): boolean;
  add(moduleId: string): void;
  delete(moduleId: string): void;
}

interface CachedModules {
  [moduleId: string]: boolean;
}

export class LocalStorageCachedModulesSet implements CachedModulesSet {
  has(moduleId: string): boolean {
    const cachedModules = this.getCachedModules();
    return cachedModules[moduleId] ?? false;
  }
  add(moduleId: string): void {
    const cachedModules = this.getCachedModules();
    this.setCachedModules({ ...cachedModules, [moduleId]: true });
  }
  delete(moduleId: string): void {
    const cachedModules = this.getCachedModules();
    this.setCachedModules({ ...cachedModules, [moduleId]: false });
  }

  private getCachedModules = (): CachedModules =>
    localStorage.getItem<CachedModules>(localStorage.Key.CACHED_MODULES) ?? {};
  private setCachedModules = (cachedModules: CachedModules) =>
    localStorage.setItem(localStorage.Key.CACHED_MODULES, cachedModules);
}
